import React from "react";

/**
 * Action Entries Accordions Component
 * Shows expandable skills and attitudes for each action
 */
const ActionAccordion = ({ entries, actionId, expandedSections, toggleSection }) => {
  const skills = entries.filter(e => e.skill).map(e => e.skill);
  const attitudes = entries.filter(e => e.attitude).map(e => e.attitude);
  const skillsKey = `action-${actionId}-skills`;
  const attitudesKey = `action-${actionId}-attitudes`;

  return (
    <div className="action-entries-accordions">
      {skills.length > 0 && (
        <div className="expandable-section compact">
          <button className="expand-btn" onClick={() => toggleSection(skillsKey)}>
            <span>Skills ({skills.length})</span>
            <span className="expand-icon">{expandedSections[skillsKey] ? "−" : "+"}</span>
          </button>
          {expandedSections[skillsKey] && (
            <div className="expanded-content">
              <ul className="entries-list">
                {skills.map((skill, idx) => (
                  <li key={idx} className="entry-item">
                    <span className="entry-text">{skill}</span>
                  </li>
                ))}
              </ul>
            </div>
          )}
        </div>
      )}
      {attitudes.length > 0 && (
        <div className="expandable-section compact">
          <button className="expand-btn" onClick={() => toggleSection(attitudesKey)}>
            <span>Attitudes ({attitudes.length})</span>
            <span className="expand-icon">{expandedSections[attitudesKey] ? "−" : "+"}</span>
          </button>
          {expandedSections[attitudesKey] && (
            <div className="expanded-content">
              <ul className="entries-list">
                {attitudes.map((attitude, idx) => (
                  <li key={idx} className="entry-item">
                    <span className="entry-text">{attitude}</span>
                  </li>
                ))}
              </ul>
            </div>
          )}
        </div>
      )}
    </div>
  );
};

export default ActionAccordion;
